(function () {
  'use strict';

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
   * Scroll reveal - shared .kab-reveal convention (see kitsters-gifting.js)
   * ------------------------------------------------------------------- */
  function initReveal(root) {
    var items = root.querySelectorAll('.kab-reveal');
    if (!items.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      items.forEach(function (it) { it.classList.add('is-in'); });
      return;
    }
    root.classList.add('kab-anim');
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    items.forEach(function (it) {
      if (it.getBoundingClientRect().top < vh * 0.85) it.classList.add('is-in');
      else io.observe(it);
    });
  }

  /* ---------------------------------------------------------------------
   * 3D tilt-on-hover cards (feature + milestone cards)
   * ------------------------------------------------------------------- */
  function initTiltCards(root) {
    if (prefersReduced) return;
    var cards = root.querySelectorAll('.kab-card[data-tilt]');
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (px * 9) + 'deg) rotateX(' + (-py * 9) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg) translateY(0)';
      });
    });
  }

  /* ---------------------------------------------------------------------
   * "Three steps" timeline reveal (rail fill + numbered dots + cards)
   * ------------------------------------------------------------------- */
  function initTimeline(root) {
    var section = root.querySelector('[data-kab-timeline]');
    if (!section) return;
    var fill = section.querySelector('.kab__timeline-fill');
    var dots = Array.prototype.slice.call(section.querySelectorAll('.kab__timeline-dot'));
    var cards = Array.prototype.slice.call(section.querySelectorAll('.kab__step-card'));

    var showFinal = function () {
      if (fill) { fill.style.transition = 'none'; fill.style.transform = 'scaleX(1)'; }
      dots.forEach(function (d) { d.style.transition = 'none'; d.style.transform = 'scale(1)'; d.style.opacity = '1'; });
      cards.forEach(function (c) { c.classList.add('is-in'); });
    };
    var reveal = function () {
      if (prefersReduced) { showFinal(); return; }
      if (fill) fill.style.transform = 'scaleX(1)';
      cards.forEach(function (c, i) { setTimeout(function () { c.classList.add('is-in'); }, 120 + i * 320); });
      dots.forEach(function (d, i) { setTimeout(function () { d.style.transform = 'scale(1)'; d.style.opacity = '1'; }, 260 + i * 320); });
    };

    if (prefersReduced || !('IntersectionObserver' in window)) { reveal(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { reveal(); io.disconnect(); }
      });
    }, { threshold: 0.25 });
    io.observe(section);
  }

  /* ---------------------------------------------------------------------
   * Hero - WebGL floating kit-box cubes (Three.js, self-hosted vendor lib)
   * Decorative only: never blocks or delays the hero text/CTA render.
   * ------------------------------------------------------------------- */
  function initHero3D(root) {
    var mount = root.querySelector('[data-kab-hero-3d]');
    if (!mount) return;
    var logoSrc = mount.getAttribute('data-logo');

    var pollTimer = null;
    var raf = null;

    var start = function () {
      var THREE = window.THREE;
      if (!THREE) { pollTimer = setTimeout(start, 120); return; }

      var reduce = prefersReduced;
      var w = mount.clientWidth || window.innerWidth;
      var h = mount.clientHeight || window.innerHeight;

      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(52, w / h, 0.1, 100);
      camera.position.z = 15;

      var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.setSize(Math.max(w, 1), Math.max(h, 1));
      mount.appendChild(renderer.domElement);

      var cubes = [];
      var CREAM = '#f3e7e2';
      var BLUE = '#465ae6';
      var kitNames = ['Tie Dye Colours', 'Sushi', 'Ice Gola', 'Cotton Candy', 'Gin Kit', 'Coffee Kit'];

      var rainbowBand = function (ctx, S, y, bh) {
        var g = ctx.createLinearGradient(0, 0, S, 0);
        g.addColorStop(0.00, '#ff5a4d');
        g.addColorStop(0.18, '#fa961e');
        g.addColorStop(0.36, '#fdda0d');
        g.addColorStop(0.54, '#5cc94a');
        g.addColorStop(0.72, '#7b7fe0');
        g.addColorStop(0.88, '#ff8fb0');
        g.addColorStop(1.00, '#7ec8f0');
        ctx.fillStyle = g;
        ctx.fillRect(0, y, S, bh);
      };

      var logoImg = null;
      var drawLogo = function (ctx, lx, ly, scale) {
        scale = scale || 1;
        if (logoImg && logoImg.naturalWidth) {
          var lw = 150 * scale;
          var lh = lw * (logoImg.naturalHeight / logoImg.naturalWidth);
          ctx.drawImage(logoImg, lx, ly - lh, lw, lh);
          return lw;
        }
        var fs = 30 * scale;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        ctx.font = '900 ' + fs + 'px "Snug-Black", "Arial Black", sans-serif';
        var kitW = ctx.measureText('KITSTERS').width;
        ctx.fillStyle = BLUE;
        ctx.fillText('KITSTERS', lx, ly);
        return kitW;
      };

      var makeBoxTexture = function (kit) {
        var S = 512;
        var cv = document.createElement('canvas');
        cv.width = cv.height = S;
        var ctx = cv.getContext('2d');
        ctx.fillStyle = CREAM;
        ctx.fillRect(0, 0, S, S);
        rainbowBand(ctx, S, 0, 58);
        rainbowBand(ctx, S, S - 58, 58);
        drawLogo(ctx, 40, 150, 1.05);
        ctx.fillStyle = BLUE;
        ctx.textAlign = 'right';
        ctx.textBaseline = 'alphabetic';
        ctx.font = '800 22px Inter, Arial, sans-serif';
        ctx.fillText('SET OF 6', S - 40, 145);
        var words = kit.toUpperCase().split(' ');
        var lines = words.length > 1
          ? [words.slice(0, Math.ceil(words.length / 2)).join(' '), words.slice(Math.ceil(words.length / 2)).join(' ')]
          : [kit.toUpperCase()];
        var fs = 96;
        var widest = function () {
          ctx.font = '900 ' + fs + 'px "Snug-Black", "Arial Black", sans-serif';
          return Math.max.apply(null, lines.map(function (l) { return ctx.measureText(l).width; }));
        };
        while (widest() > S - 96 && fs > 34) fs -= 3;
        var lh2 = fs * 0.92;
        var cy = S * 0.46;
        var startY = cy - (lines.length - 1) * lh2 / 2;
        ctx.fillStyle = BLUE;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        lines.forEach(function (l, i) { ctx.fillText(l, S / 2, startY + i * lh2); });
        ctx.font = '800 20px Inter, Arial, sans-serif';
        ctx.fillText('JUST ADD WATER & GET STARTED!', S / 2, S * 0.72);
        var tex = new THREE.CanvasTexture(cv);
        try { tex.anisotropy = renderer.capabilities.getMaxAnisotropy(); } catch (e) { tex.anisotropy = 4; }
        return tex;
      };

      var buildCubes = function () {
        /* Where the copy actually ends, MEASURED off the element rather than
           modelled from the CSS. The first cut used a fixed fraction of the
           frustum and a numeric sweep showed why that cannot work: the copy
           column is a fixed 720px, so it takes a BIGGER share of a narrow
           viewport - 45% at 1920 but 64% at 1280 - and any single fraction is
           either wasteful on wide screens or still overlapping on laptops.

           Three things then push a box back toward the copy after placement and
           all three are paid for below: the camera pans up to 2 units on mouse
           move, a cube is up to 1.6 units of half-width, and a cube at the far
           end of the z spread sits 19 units from the camera instead of 15, so it
           projects NEARER the centre than its world x suggests. */
        /* Owner 2026-09-01: "divide whole section 45 and 55 percentage, right 55
           percentage should be the box". The canvas is position:absolute inset:0
           on .kab__hero, so the mount IS the section and a screen fraction maps
           straight onto it - 0.45 here is literally the owner's 45% line.

           Placed by SCREEN FRACTION, not by a world-x band. A band in world units
           cannot hold a split, because a cube's screen position depends on its
           depth: the same x sits at 56% of the width at the back of the scene and
           60% at the front. Deriving each cube's own half-width from its own z is
           what makes the 45% line true for every cube instead of on average.

           The scrim already assumed this split - it is a 90deg gradient stepping
           from 0.78 black to 0.4 at exactly 46% - so the cubes were the only part
           of the hero not honouring it. */
        var BAND_START = 0.45;
        /* 0.45 is the target; the copy's real right edge is the floor. They are
           not the same number, and the difference is not a rounding error:
           .kab__hero-inner is capped at 1620px and CENTRED, so above ~1700px the
           gutter grows and the copy's right edge drifts to 46.5% of the VIEWPORT
           at 2560 while still sitting at 45% of its own container. The CSS cap is
           relative to the container, this band is relative to the section, so a
           flat 0.45 put cubes over the last ~38px of the paragraph on a wide
           screen - measured, not predicted. Reading the element makes the split as
           tight as the layout truly allows and keeps it honest if the copy width
           ever changes again. */
        var copyEl = mount.parentNode && mount.parentNode.querySelector('.kab__hero-copy');
        var mRect = mount.getBoundingClientRect();
        if (copyEl && mRect.width) {
          var cRect = copyEl.getBoundingClientRect();
          BAND_START = Math.max(BAND_START, (cRect.right - mRect.left) / mRect.width + 0.005);
        }
        /* Stop short of the right edge so at least one face of the rightmost cube
           stays on screen; cubes still overhang and crop, which is the look. */
        var BAND_END = 0.98;
        var TAN_HALF_FOV = Math.tan((camera.fov * Math.PI / 180) / 2);
        var halfW = TAN_HALF_FOV * camera.position.z * camera.aspect;

        /* Portrait has no "right side" to move to - the copy stacks above the
           canvas and the scrim turns vertical (see the max-width:768px rule in
           kitsters-about.css), so the full spread is correct there and this is a
           no-change for phones. */
        var splitBand = camera.aspect >= 1;

        for (var i = 0; i < 15; i++) {
          var s = 1.3 + Math.random() * 1.9;
          var geo = new THREE.BoxGeometry(s, s, s);
          var mat = new THREE.MeshBasicMaterial({ map: makeBoxTexture(kitNames[i % kitNames.length]) });
          var mesh = new THREE.Mesh(geo, mat);
          var edges = new THREE.LineSegments(
            new THREE.EdgesGeometry(geo),
            new THREE.LineBasicMaterial({ color: 0x0a0a0a, linewidth: 2 })
          );
          mesh.add(edges);
          /* They were spread across the full width (x from -11 to +11) while the
             copy column sits on the LEFT, so cream boxes landed on top of white
             text - "text art not visible due to box". A scrim cannot save text
             with a box over it, so the placement itself had to move. See
             BAND_START above for the 45/55 split this now lands on. */
          var cz = (Math.random() - 0.5) * 8;
          var cx;
          if (splitBand) {
            /* Half-width of the frustum AT THIS CUBE'S DEPTH. Nearer cubes (larger
               cz) sit in a narrower frustum, so the same fraction needs a smaller
               world x - which is exactly why a shared band could not hold. */
            var hw = TAN_HALF_FOV * (camera.position.z - cz) * camera.aspect;
            /* Worst-case half width of a cube free to tumble on two axes: the
               body diagonal of a face, s*sqrt(3)/2. Adding it here and measuring
               the fraction from the LEFT EDGE means fLeft is where the paint
               starts, not where the centre lands - a 3.2-unit cube centred on the
               line would otherwise hang ~1.6 units over the copy. */
            var r = s * 0.866;
            var fLeft = BAND_START + Math.random() * (BAND_END - BAND_START);
            cx = (fLeft - 0.5) * 2 * hw + r;
          } else {
            cx = (Math.random() - 0.5) * 22;
          }
          mesh.position.set(cx, (Math.random() - 0.5) * 13, cz);
          mesh.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, 0);
          mesh.userData = {
            rx: (Math.random() - 0.5) * 0.006,
            ry: (Math.random() - 0.5) * 0.006,
            phase: Math.random() * Math.PI * 2,
            amp: 0.3 + Math.random() * 0.6,
            baseY: mesh.position.y
          };
          scene.add(mesh);
          cubes.push(mesh);
        }
        render();
      };

      var logoReady = new Promise(function (res) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () { logoImg = im; res(); };
        im.onerror = function () { res(); };
        im.src = logoSrc;
        setTimeout(res, 2000);
      });

      var safeBuild = function () {
        if (cubes.length) return;
        try { buildCubes(); } catch (e) { /* decorative only - fail silent */ }
      };
      var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
      Promise.all([fontsReady.catch(function () {}), logoReady]).then(safeBuild);
      setTimeout(safeBuild, 2600);

      var mx = 0, my = 0;
      var onMove = function (e) {
        mx = (e.clientX / window.innerWidth - 0.5);
        my = (e.clientY / window.innerHeight - 0.5);
      };
      var clock = new THREE.Clock();

      function render() {
        var t = clock.getElapsedTime();
        if (!reduce) {
          cubes.forEach(function (c) {
            c.rotation.x += c.userData.rx;
            c.rotation.y += c.userData.ry;
            c.position.y = c.userData.baseY + Math.sin(t + c.userData.phase) * c.userData.amp * 0.5;
          });
          camera.position.x += (mx * 4 - camera.position.x) * 0.05;
          camera.position.y += (-my * 3 - camera.position.y) * 0.05;
          camera.lookAt(0, 0, 0);
        }
        renderer.render(scene, camera);
      }

      var loop = function () { render(); raf = requestAnimationFrame(loop); };

      if (reduce) {
        render();
      } else {
        window.addEventListener('mousemove', onMove);
        loop();
      }

      var onResize = function () {
        var nw = mount.clientWidth, nh = mount.clientHeight;
        if (!nw || !nh) return;
        w = nw; h = nh;
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
        renderer.setSize(w, h);
      };
      window.addEventListener('resize', onResize);

      var ro = null;
      if (typeof ResizeObserver !== 'undefined') {
        ro = new ResizeObserver(function () { onResize(); });
        ro.observe(mount);
      }
      var ensureSized = function () {
        if (mount.clientWidth > 0 && mount.clientHeight > 0) { onResize(); render(); return; }
        requestAnimationFrame(ensureSized);
      };
      requestAnimationFrame(ensureSized);
    };

    start();
  }

  function init() {
    var root = document.querySelector('.kab');
    if (!root) return;
    initReveal(root);
    initTiltCards(root);
    initTimeline(root);
    initHero3D(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
